module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "section-no",
    attrs: {
      "id": "tocsec-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('span', {
    staticClass: "pt"
  }, [_vm._v("SECTION A")])])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('h1', {
    staticClass: "sec-title"
  }, [_c('strong', [_vm._v("Questions Related to the Quest for the Historical Jesus")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1618abc3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/010_Section1A.vue
// module id = 84
// module chunks = 0